export const PREFERRED_SOURCE_URL = 'https://www.google.com/preferences/source?q=tagvenue.com';

export const DISMISS_STORAGE_KEY = 'preferred-source-banner-dismissed';

export const DISMISS_STORAGE_VALUE = '1';

export const isPreferredSourceBannerDismissed = () => {
  try {
    return localStorage.getItem(DISMISS_STORAGE_KEY) === DISMISS_STORAGE_VALUE;
  } catch {
    return false;
  }
};

export const dismissPreferredSourceBanner = () => {
  try {
    localStorage.setItem(DISMISS_STORAGE_KEY, DISMISS_STORAGE_VALUE);
  } catch {
    // storage unavailable (e.g. blocked) – banner stays dismissible per page view
  }
};

export const initPreferredSourceBanners = (trackEvent) => {
  const banners = [...document.querySelectorAll('[data-preferred-source-banner]')];

  if (banners.length === 0) {
    return;
  }

  const hideAllBanners = () => banners.forEach((banner) => {
    banner.style.display = 'none';
  });

  if (isPreferredSourceBannerDismissed()) {
    hideAllBanners();
    return;
  }

  banners.forEach((banner) => {
    const trackInteraction = (element, interaction) => trackEvent({
      section: 'preferred_source_banner',
      element,
      interaction,
    });

    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackInteraction(banner.dataset.element, 'visible');
            observer.unobserve(entry.target);
          }
        });
      });

      observer.observe(banner);
    }

    banner.querySelector('.js-preferred-source-cta')?.addEventListener('click', () => {
      trackInteraction('button', 'click');
      dismissPreferredSourceBanner();
      hideAllBanners();
    });

    banner.querySelector('.js-preferred-source-dismiss')?.addEventListener('click', () => {
      trackInteraction('close_x', 'click');
      dismissPreferredSourceBanner();
      hideAllBanners();
    });
  });
};
